export default {
  // Load the industry reference list
  industries(state, payload) {
    state.industries = payload || [];
  },
  industriesTimestamp(state) {
    state.industriesTimestamp = String(
      Math.round(new Date().getTime() / 1000),
    );
  },
  industriesTimestampReset(state) {
    state.industriesTimestamp = null;
  },
  // Load the company's job posts
  jobs(state, payload) {
    state.jobs = payload || [];
  },
  jobsTimestamp(state) {
    state.jobsTimestamp = String(Math.round(new Date().getTime() / 1000));
  },
  jobsTimestampReset(state) {
    state.jobsTimestamp = null;
  },
  jobsLoading(state, payload) {
    state.jobsLoading = payload === true;
  },
  // Load the company's clients
  clients(state, payload) {
    state.clients = payload || [];
  },
  // A newly created client, so the dropdown can select it without a refetch.
  clientAdd(state, payload) {
    if (payload) {
      state.clients = [...state.clients, payload];
    }
  },
  clientRemove(state, payload) {
    state.clients = state.clients.filter(
      (client) => client.clientId != payload.clientId,
    );
  },
  // Swap an updated client into the list, in place.
  clientUpdate(state, payload) {
    if (payload) {
      state.clients = state.clients.map((client) =>
        client.clientId == payload.clientId ? payload : client,
      );
    }
  },
  // Push a newly added candidate onto the job, so the board shows them without
  // refetching the whole list.
  // Who has opened a job (FR-11), as the server returns it after mark-viewed.
  jobViewed(state, payload) {
    const job = state.jobs.find((item) => item.jobId == payload.jobId);

    if (job) {
      job.viewed = payload.viewed || [];
    }
  },
  applicantAdd(state, payload) {
    const job = state.jobs.find((item) => item.jobId == payload.jobId);

    if (job && payload.applicant) {
      job.applicants = [...job.applicants, payload.applicant];
    }
  },
  // Replace one applicant in place after a stage or sub-status change, so the
  // board reflects the server's response without refetching the whole list.
  applicantUpdate(state, payload) {
    const job = state.jobs.find((item) => item.jobId == payload.jobId);

    if (!job || !payload.applicant) {
      return;
    }

    job.applicants = job.applicants.map((applicant) =>
      applicant.applicantId == payload.applicant.applicantId
        ? { ...applicant, ...payload.applicant }
        : applicant,
    );
  },
  clientsTimestamp(state) {
    state.clientsTimestamp = String(Math.round(new Date().getTime() / 1000));
  },
  clientsTimestampReset(state) {
    state.clientsTimestamp = null;
  },
};
